import { Component, OnInit, OnDestroy } from "@angular/core";
import {
  BrowserModule,
  DomSanitizer,
  SafeResourceUrl,
} from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";

// Servicios
import { InterestSiteService, StorageService } from "../../../service/service.index";

// COMPONENT SERVICES
import { AdminNavService } from "../../../components/layouts/administrator/admin-nav/admin-nav.service";
import { AdminHeaderService } from "../../../components/layouts/administrator/admin-header/admin-header.service";
import { Pdf } from "src/app/models/catalogs/pdf.model";
import { Appsettings } from "src/app/configuration/appsettings";

@Component({
  selector: "app-service",
  templateUrl: "./service.component.html",
  styleUrls: ["./service.component.scss"],
})
export class ServiceComponent implements OnInit, OnDestroy {
  pageurl: SafeResourceUrl;
  working: boolean;
  showPdf: boolean;
  selectId: number;
  banderaPdf: number;

  nameFiles = {
    sitios_de_interes: {
      name: "ligas_de_interes",
      title: "Sitios de interés",
    },

    software_gratuito: {
      name: "Ligas_software_gratuito",
      title: "Software gratuito",
    },

    servicios_pedagogicos: {
      name: "Servicios_pedagogicos",
      title: "Servicios pedagógicos",
    },
  };

  pdfs: Pdf[] = [];
  pdf: Pdf[];
  urlInt: string = "";
  nameFile: string = "";
  constructor(
    private _domSanitizer: DomSanitizer,
    public _srvStorage: StorageService,
    public _srvAdminNav: AdminNavService,
    private route: ActivatedRoute,
    public _srvHeaderAdmin: AdminHeaderService,
    private _srvSite: InterestSiteService
  ) {
    this.working = false;
    this.showPdf = false;
  }

  ngOnInit() {
    this._srvHeaderAdmin.setUrlBackButton(["/resource/home", "Inicio"]);
    this.route.params.subscribe((params) => {
      console.log(params["id"]);

      const id = params["id"];

      const nameFile = this.nameFiles[id];
      this.nameFile = this.nameFiles[id];
      if (nameFile) {
        this._srvAdminNav.setTitle(nameFile.title);
      }
      this.viewFile(nameFile.name, id);
    });
  }

  ngOnDestroy(): void {
    this._srvHeaderAdmin.setUrlBackButton([]);
  }

  viewFile(nameFile: string, id: number) {
    this.selectId = id;
    let file;
    // this.banderaPdf = ( this._srvStorage.rol == 'Profesor Bachillerato') ? 2 : 1 ;
    this.showPdf = nameFile === "Servicios_pedagogicos" ? true : false;

    if (nameFile === "Servicios_pedagogicos") {
      if (
        this._srvStorage.rol == "Profesor Bachillerato" ||
        this._srvStorage.rol == "Alumno Bachillerato"
      ) {
        file = "Catalogo_Servicios_Pedagogicos_bachiller";
      } else {
        file = nameFile;
      }
    }

    if (nameFile === "ligas_de_interes") {
      if (
        this._srvStorage.rol == "Profesor Bachillerato" ||
        this._srvStorage.rol == "Alumno Bachillerato"
      ) {
        file = "ligas_de_interes_bachillerato";
      } else {
        file = nameFile;
      }
    }

    if (nameFile === "Ligas_software_gratuito") {
      if (
        this._srvStorage.rol == "Profesor Bachillerato" ||
        this._srvStorage.rol == "Alumno Bachillerato"
      ) {
        file = "Ligas_software_gratuito_bachillerato";
      } else {
        file = nameFile;
      }
    }

    if (
      nameFile === "ligas_de_interes" ||
      nameFile === "Ligas_software_gratuito"
    ) {
      this._srvSite.getAllfiles().subscribe((res) => {
        this.pdfs = res.data;
        const idFilter = nameFile === "ligas_de_interes" ? 2 : 1;
        this.pdf = this.pdfs.filter((x) => x.module == idFilter);
        console.log(this.pdf);

        if (this.pdf.length > 0) {
          this.getPdf(this.pdf[0].id);
        }
      });
    } else {
      let apiUrl = `../../../../assets/docs/${file}.pdf`;
      this.pageurl = this._domSanitizer.bypassSecurityTrustResourceUrl(
        apiUrl + "#toolbar=0&navpanes=0&scrollbar=0"
      );
    }
  }

  getPdf(idFile) {
    
    let apiUrl = `${Appsettings.API_ENDPOINT_FULL}/modulefiles/${idFile}/download`;
    this.pageurl = this._domSanitizer.bypassSecurityTrustResourceUrl(apiUrl);
  }
}
